import './Style/App.scss'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import LoginPage from './Pages/LoginPage';
import ContainerPage from './Pages/ContainerPage';
import PageNotFound from './Pages/PageNotFound';
import DashboardPage from './Pages/DashboardPage';
import WorkerPage from './Pages/WorkerPage';
import { library } from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
library.add(fas)

function App() {
  let isauthenticated = localStorage.getItem("isauthenticated");
  return (
    <BrowserRouter>
      <Routes>
        {!isauthenticated && 
          <>
            <Route path="" element={<LoginPage />} />
          </>          
        }
        {isauthenticated && 
          <>
            <Route path="" element={<ContainerPage />}>
              <Route index element={<DashboardPage />}/>
              <Route path="workers" >
                <Route index element={<WorkerPage />}/>
              </Route>
            </Route>
          </>          
        }
        <Route path="*" element={<PageNotFound />} />
      </Routes>    
    </BrowserRouter>
  );
}

export default App;
